var exports = {
  "kL": "x31de4314--331b33--container",
  "vK": "x31de4314--331b33--banner",
  "Qq": "x31de4314--331b33--text",
};

module.exports = exports;
